export default __webpack_public_path__ + "static/media/list-light.a2802512.svg";